<script setup lang="ts">
import { useUiStore } from '@/stores/ui';

const ui = useUiStore();

const toastClass = {
  success: 'text-bg-success',
  error: 'text-bg-danger',
  warning: 'text-bg-warning',
} as const;
</script>

<template>
  <RouterView />

  <div v-if="ui.busy" class="app-spinner" role="status" aria-live="polite">
    <div class="spinner-border text-light" />
    <span class="visually-hidden">{{ $t('loading') }}</span>
  </div>

  <div class="toast-container position-fixed p-3" aria-live="polite">
    <div
      v-for="toast in ui.toasts"
      :key="toast.id"
      class="toast show align-items-center border-0"
      :class="toastClass[toast.type]"
      role="alert"
    >
      <div class="d-flex">
        <div class="toast-body">{{ toast.message }}</div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          :aria-label="$t('close')"
          @click="ui.removeToast(toast.id)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.app-spinner {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(0 0 0 / 35%);
}

.toast-container {
  z-index: 2100;
  // Phones: across the bottom, inside the viewport. Larger screens: top right.
  bottom: 0;
  left: 0;
  right: 0;

  .toast {
    width: 100%;
    max-width: 100%;
  }

  @media (min-width: 576px) {
    top: 0;
    bottom: auto;
    left: auto;

    .toast {
      width: 350px;
    }
  }
}
</style>
